import { render, staticRenderFns } from "./VirtualPatient.vue?vue&type=template&id=6085bb98&scoped=true"
import script from "./VirtualPatient.vue?vue&type=script&lang=js"
export * from "./VirtualPatient.vue?vue&type=script&lang=js"
import style0 from "./VirtualPatient.vue?vue&type=style&index=0&id=6085bb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085bb98",
  null
  
)

export default component.exports